import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import moment from 'moment';
import Badge from '../../../shared/packages/Badge';

class Feed extends Component {
  render() {
    const {
      item
    } = this.props;

    const catcid = _.get(item, 'category.cid');
    const catName = _.get(item, 'category.name');

    return (
      <a href={`//omni-feedback.aws-origin.xfinity.com/topic/${item.slug}`} className={`community-feed__item community-feed__item--singular community-feed__item--${catcid}`}>
        <Badge className={`community-feed-badge community-feed-badge--${catcid}`}>
          {catName}
        </Badge>
        <div className="community-feed-post">
          <div className="community-feed-user">
            {item.user.picture &&
              <img className="community-feed-user-picture" src={`//omni-feedback.aws-origin.xfinity.com${item.user.picture}`} />
            }
            {!item.user.picture &&
              <div className="community-feed-user-icon" style={{'backgroundColor': item.user['icon:bgColor']}}>
                {item.user['icon:text']}
              </div>
            }
          </div>
          <div className="community-feed-title community-feed-post-content">
            <span className="x-body2">{item.title}</span>
          </div>
          <div className="community-feed-date community-feed-post-content">
            <span className="x-body2">{moment(item.timestampISO).format('YYYY[-]MM[-]DD')}</span>
          </div>
        </div>
      </a>
    );
  }
}

Feed.propTypes = {
  item: PropTypes.object
};

export default Feed;



/** WEBPACK FOOTER **
 ** ./client/components/Omni/OmniSales/FeedItemSingle.jsx
 **/